import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  video: {
    display: 'block',
    margin: 'auto',
    maxWidth: '100%'
  }
}))
